<template>
  <div>
    <div class="name">
      <h2>JONATHAN J. MOSER</h2>
    </div>
    <div class="buttoncontainer">
      <router-link to="/"><button :class="{isactive: (activeindex == 1)}">Portfolio</button></router-link>
      <router-link to="resume"><button :class="{isactive: (activeindex == 2)}">Resume</button></router-link>
    </div>
  </div>
</template>

<script>
export default{
  props: ['active'],
  data(){
    return{
      activeindex: this.active
    }
  },
}
</script>

<style scoped>
h2{
  letter-spacing: 4px;
  font-weight: 300;
  font-size: 18px;
}
.buttoncontainer{
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1vw 0;
  padding: 0 1vw;
}
.name,
.buttoncontainer{
  color: gray;
  font-family: inherit;
  font-size: 14px;
}
.name{
  position: absolute;
  left: 15px;
  top: 10px;
}
a{
  display: block;
  margin: 0 0 10px;
}
button{
  display: block;
  outline: none;
  text-decoration: none;
  background-color: #ddd;
  border: none;
  width: 150px;
  height: 50px;
  font-family: inherit;
}
.isactive{
  background-color: #aaa;
}

@media screen and (max-width: 1200px){
  .buttoncontainer,
  .name{
    position: static;
  }
  .buttoncontainer{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .name{
    text-align: center;
  }
  button{
    height: 32px;
  }
}
</style>
